import { FC } from 'react';
import { ISelectOption } from '../../../types';
import { ClinicianView } from '../../../types/clinician';
import { getInitials } from '../../../utils';
import styles from './styles.module.css';

const ClinicianOption: FC<ISelectOption<ClinicianView>> = (props) => {

  const {
    data,
  } = props;

  const initials = getInitials(data?.name || '');

  return (
    <div className={styles.wrapper}>

      <div className={styles.avatar}>
        {initials}
      </div>

      <div className={styles.nameWrapper}>
        <div className={styles.name}>
          {data?.name}
        </div>
        <div className={styles.email}>
          {data?.email}
        </div>
      </div>

      <div className={styles.addButton}>
        <span className={styles.addIcon}>+</span>
      </div>

    </div>
  );

};

export default ClinicianOption;
